<div>
  <nx-pageTitle-box
    [label]="ownTenant? ('Account' + (this.viewMode ? ' anzeigen' : ' bearbeiten')): ('Tenant' + (this.id ? ' bearbeiten' : ' anlegen'))"
    [bcRootLvlLabel]="'Tenants'"
    [bcRootLvlPath]="'settings/tenants'"
    [icon]="ownTenant? 'icon-user':'icon-tenant'"
    [iconToolTip]=""
    [menuItems]="ownTenant && viewMode?  pageTitleMenuItems: []">
    </nx-pageTitle-box>
<div class="body white">
  <div class="flex-row">
    <div [formGroup]="tenantFormGroup" class="flex flex-col gap-25">
      <!-- <mat-form-field class="basis-full">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name">
      </mat-form-field> -->
      <!-- <mat-form-field class="basis-full">
        <mat-label>Zusätzlicher Name</mat-label>
        <input matInput formControlName="additionalName">
      </mat-form-field> -->
      <!-- <mat-form-field class="basis-full">
        <mat-error *ngIf="tenantFormGroup.get('email')?.hasError('pattern')">
          Bitte gib eine gültige E-Mai-Adresse ein.
        </mat-error>
        <mat-label>E-Mail</mat-label>
        <input matInput formControlName="email">
      </mat-form-field> -->
      <!-- <mat-form-field appearance="fill" class="basis-full">
        <mat-label>Beschreibung</mat-label>
        <textarea matInput cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3"
          formControlName="description">
                            </textarea>
      </mat-form-field> -->
      <div class="flex flex-row space-x-4" style="margin-bottom:0px">
        <!-- <mat-form-field class="basis-1/2">
          <mat-label>Addresszeile 1</mat-label>
          <input matInput formControlName="addressLine0" onwheel="document.activeElement.blur()">
        </mat-form-field> -->
        <!-- <mat-form-field class="basis-1/2">
          <mat-label>Addresszeile 2</mat-label>
          <input matInput formControlName="addressLine1" onwheel="document.activeElement.blur()">
        </mat-form-field> -->
      </div>
      <div class="flex flex-row space-x-4" style="margin-bottom:0px">
        <!-- <mat-form-field class="basis-1/2">
          <mat-label>Postleitzahl</mat-label>
          <input matInput formControlName="postalCode" onwheel="document.activeElement.blur()">
        </mat-form-field> -->
        <!-- <mat-form-field class="basis-1/2">
          <mat-label>Ort</mat-label>
          <input matInput formControlName="city" onwheel="document.activeElement.blur()">
        </mat-form-field> -->
      </div>
      <div class="basis-full">
          <mat-select-country
          label="Land"
          class="className"
          formControlName="country"
          [nullable]="true"
          (onCountrySelected)="onCountrySelected($event)">
        </mat-select-country>
      </div>
      <mat-form-field class="basis-full">
        <mat-label>Umsatzsteuer-Identifikationsnummer</mat-label>
        <input matInput formControlName="vatNumber" onwheel="document.activeElement.blur()">
      </mat-form-field>
      <mat-form-field class="basis-full">
        <mat-label>Telefonnummer</mat-label>
        <input matInput formControlName="phone" onwheel="document.activeElement.blur()">
      </mat-form-field>
      <ng-container *ngIf="!ownTenant && hasTenantRole">
        <mat-slide-toggle formControlName="paymentProviderEnabled" class="pt-3 pb-5" [checked]="false">Zahlungsanbieter-Integration</mat-slide-toggle>
      </ng-container>
      <ng-container *ngIf="!ownTenant && hasTenantRole && hasEmployeeRole">
        <mat-form-field class="basis-full">
          <mat-label>Zahlungsanbieter Id</mat-label>
          <input matInput formControlName="paymentProviderId" onwheel="document.activeElement.blur()">
        </mat-form-field>
      </ng-container>

    </div>

  </div>
  <div class="basis-full flex flex-row-reverse start">
    <button mat-flat-button (click)="abort()" id="cancel"  [disabled]="viewMode" color="primary">Abbrechen</button>
    <button mat-flat-button (click)="saveTenant()" id="save" color="primary"
      [disabled]="checkValid()">Speichern</button>
  </div>

</div>
</div>
